import { SELFCARE_STEPS } from 'routes/steps'
import { useApp } from 'store/steps'
import DesktopNavigation from './DesktopNavigation'
import { useSelfcareAuth } from 'routes/selfcare/auth/useSelfcareAuth'

const SelfcareDesktopNavigation = () => {
    const { stepId } = useApp()
    const { isAuthenticated } = useSelfcareAuth()

    const shouldShowNavigation =
        stepId !== 'starter' && stepId !== 'selfcare_login' && isAuthenticated

    return shouldShowNavigation ? (
        <DesktopNavigation steps={SELFCARE_STEPS} stepId={stepId} />
    ) : null
}

export default SelfcareDesktopNavigation
